﻿$.fn.dxCtrlBuilderEmailPageMiseEnPage = function custom_dxCtrlBuilderEmailPageMiseEnPage(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlbuilderemailpagemiseenpage dx-ctrl");
        this.createInstance(new cdxCtrlBuilderEmailPageMiseEnPage(this, option));
    }
    return this;
}

window.cdxCtrlBuilderEmailPageMiseEnPage = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var dxScroll = null
    this.mGetDxScroll = function () { return dxScroll }
    function mConstruit() {
        container.empty()
        dxScroll = $("<div style='height:100%;'/>").appendTo(container).dxScrollView({}).dxScrollView("instance")

        if (typeof option.idxSelected == 'undefined') option.idxSelected = 0
        var ds = [{ id: 0, text: "Page" },
        { id: 1, text: "Bloc widget" },
        { id: 2, text: "Texte" },
        { id: 3, text: "Lien" },
        { id: 4, text: "Bouton" },
        { id: 5, text: "Séparateur" }]
        dxAccord = $("<div style='background-color:" + theme.backgroundColorTitle + ";'/>").appendTo(dxScroll.content()).dxCtrlAccordion({
            stickyTitle: true,
            dataSource: ds,
            selectedIds: [option.idxSelected],
            multiple: false,
            itemClosed: function () { },
            itemOpened: function () { },
            itemTitleTemplate: function (itemData, itemIndex, itemElement) {
                itemElement.css("color", theme.backgroundcolorAccent)
                if (itemIndex == 0) itemElement.css("border-top", "")
                var $Table = $("<table style='width:92%'/>").appendTo(itemElement)
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:100%;font-size:180%;font-weight:Bold;'>" + itemData.text + "</td>").appendTo($Tr)
                var $Td = $("<td style='width:1px'></td>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxCtrlButton({
                    icon: 'fas fa-text-slash',
                    width: HeightButton - 20,
                    height: HeightButton - 20,
                    txtTooltip: "Rétablir<br/>les styles initiaux",
                    onClick: function (e) {
                        e.event.stopPropagation()
                        switch (itemData.id) {
                            case 0: //page
                                option.dxBuilderEmailPage.mJsonCssGuideProperty("bodypage", null, option.dxBuilderEmailPage.jsonCssGuideBase.bodypage)
                                option.dxBuilderEmailPage.mJsonCssGuideProperty("bodymessage", null, option.dxBuilderEmailPage.jsonCssGuideBase.bodymessage)
                                if (typeof itemData.itemElement != 'undefined') {
                                    itemData.itemElement.css("height", ((itemData.itemElement.innerHeight() > 0) ? itemData.itemElement.innerHeight() + "px" : ""))
                                    mRempliPage(itemData.itemElement)
                                    itemData.itemElement.css("height", "")
                                }
                                break;
                            case 1: //bloc
                                option.dxBuilderEmailPage.mJsonCssGuideProperty("blocwidget", null, option.dxBuilderEmailPage.jsonCssGuideBase.blocwidget)
                                if (typeof itemData.itemElement != 'undefined') {
                                    itemData.itemElement.css("height", ((itemData.itemElement.innerHeight() > 0) ? itemData.itemElement.innerHeight() + "px" : ""))
                                    mRempliWidget(itemData.itemElement)
                                    itemData.itemElement.css("height", "")
                                }
                                break;
                            case 2://Texte
                                option.dxBuilderEmailPage.mJsonCssGuideProperty(currentTag, null, option.dxBuilderEmailPage.jsonCssGuideBase[currentTag])
                                if (typeof itemData.itemElement != 'undefined') {
                                    itemData.itemElement.css("height", ((itemData.itemElement.innerHeight() > 0) ? itemData.itemElement.innerHeight() + "px" : ""))
                                    mRempliText(itemData.itemElement)
                                    itemData.itemElement.css("height", "")
                                }
                                break;
                            case 3: //lien
                                option.dxBuilderEmailPage.mJsonCssGuideProperty("a", null, option.dxBuilderEmailPage.jsonCssGuideBase.a)
                                if (typeof itemData.itemElement != 'undefined') {
                                    itemData.itemElement.css("height", ((itemData.itemElement.innerHeight() > 0) ? itemData.itemElement.innerHeight() + "px" : ""))
                                    mRempliLien(itemData.itemElement)
                                    itemData.itemElement.css("height", "")
                                }
                                break;
                            case 4: //Bouton
                                option.dxBuilderEmailPage.mJsonCssGuideProperty("bouton", null, option.dxBuilderEmailPage.jsonCssGuideBase.bouton)
                                if (typeof itemData.itemElement != 'undefined') {
                                    itemData.itemElement.css("height", ((itemData.itemElement.innerHeight() > 0) ? itemData.itemElement.innerHeight() + "px" : ""))
                                    mRempliBt(itemData.itemElement)
                                    itemData.itemElement.css("height", "")
                                }
                                break;
                            case 5: //Séparateur
                                option.dxBuilderEmailPage.mJsonCssGuideProperty("separateur", null, option.dxBuilderEmailPage.jsonCssGuideBase.separateur)
                                if (typeof itemData.itemElement != 'undefined') {
                                    itemData.itemElement.css("height", ((itemData.itemElement.innerHeight() > 0) ? itemData.itemElement.innerHeight() + "px" : ""))
                                    mRempliSeparateur(itemData.itemElement)
                                    itemData.itemElement.css("height", "")
                                }
                                break;
                        }
                        option.onValueChanged()
                    }
                })
            },
            itemTemplate: function (itemData, itemIndex, itemElement) {
                dxWidgetFont = null
                itemData.itemElement = itemElement
                itemElement.css("padding", "0 30px 30px 30px")
                switch (itemData.id) {
                    case 0: mRempliPage(itemElement); break; //page
                    case 1: mRempliWidget(itemElement); break; //Text
                    case 2: itemElement.css("padding", "0"); mRempliText(itemElement); break; //Text
                    case 3: mRempliLien(itemElement);; break; //Lien
                    case 4: mRempliBt(itemElement); break; //Bouton
                    case 5: mRempliSeparateur(itemElement); break; //séparateur
                }
            },
            onContentReady: function (e) {
                e.element.find(".dx-accordion-item-title").css("overflow", "hidden")
                //e.element.find(".dx-accordion-item-title").css("border", "none")
            }
        }).dxCtrlAccordion("instance")
    }

    function mRempliPage(itemElement) {
        itemElement.empty()
        $("<br/>").appendTo(itemElement)
        if (option.isFormulaire) {
            $("<div style='width:1px;white-space:nowrap;font-size:140%;font-weight:bold;' class=''>Titre de la page:</div>").appendTo(itemElement)
            $("<div/>").appendTo(itemElement).dxCtrlTextBox({
                placeholder: "Titre de la page",
                value: option.dxBuilderEmailPage.mTitre(),
                onValueChanged: function (e) {
                    option.dxBuilderEmailPage.mTitre((!e.value ? "" : e.value))
                    option.onValueChanged()
                },
            })
        }

        $("<br/>").appendTo(itemElement)
        $("<br/>").appendTo(itemElement)
        $("<div style='width:1px;white-space:nowrap;font-size:140%;font-weight:bold;' class=''>Largeur message:</div>").appendTo(itemElement)
        $("<div/>").appendTo(itemElement).dxSlider({
            min: 100,
            max: 2500,
            step: 50,
            value: option.dxBuilderEmailPage.mJsonCssGuideProperty("bodymessage", "max-width").replace("px", ""),
            onValueChanged: function (e) {
                option.dxBuilderEmailPage.mJsonCssGuideProperty("bodymessage", "max-width", e.value + "px")
                option.onValueChanged()
            },
            tooltip: {
                enabled: true,
                format(value) {
                    return `${value}px`;
                },
                showMode: 'always',
                position: 'bottom',
            },
            onContentReady: function (e) { window.setTimeout(function () { e.component.repaint() }, 0) }
        }).dxSlider("instance")

        $("<br/>").appendTo(itemElement)
        $("<br/>").appendTo(itemElement)
        $("<div style='width:1px;white-space:nowrap;font-size:140%;font-weight:bold;' class=''>Couleur:</div>").appendTo(itemElement)
        $("<div  style='margin:5px 0;'/>").appendTo(itemElement).dxCtrlColorPicker({
            value: option.dxBuilderEmailPage.mJsonCssGuideProperty("bodypage", "background-color"),
            title: "Couleur arrière plan de la page",
            titlePaletteSelect: "Couleur dans votre email",
            getPaletteSelect: option.dxBuilderEmailPage.mGetLstColor,
            onValueChanged: function (e) {
                option.dxBuilderEmailPage.mJsonCssGuideProperty("bodypage", "background-color", e.value)
                option.onValueChanged()
            }
        })
        $("<div  style='margin:5px 0;'/>").appendTo(itemElement).dxCtrlColorPicker({
            value: option.dxBuilderEmailPage.mJsonCssGuideProperty("bodymessage", "background-color"),
            title: "Couleur arrière plan du message",
            titlePaletteSelect: "Couleur dans votre email",
            getPaletteSelect: option.dxBuilderEmailPage.mGetLstColor,
            onValueChanged: function (e) {
                option.dxBuilderEmailPage.mJsonCssGuideProperty("bodymessage", "background-color", e.value)
                option.onValueChanged()
            }
        })

        $("<br/>").appendTo(itemElement)
        $("<br/>").appendTo(itemElement)
        $("<div style='width:1px;white-space:nowrap;font-size:140%;font-weight:bold;' class=''>Marge de la page:</div>").appendTo(itemElement)
        $("<div/>").appendTo(itemElement).dxCtrlBuilderEmailStylePadding({
            type: "padding",
            allowDefaut: false,
            padTop: option.dxBuilderEmailPage.mJsonCssGuideProperty("bodypage", "padding-top").replace("px", ""),
            padBottom: option.dxBuilderEmailPage.mJsonCssGuideProperty("bodypage", "padding-bottom").replace("px", ""),
            padLeft: option.dxBuilderEmailPage.mJsonCssGuideProperty("bodypage", "padding-left").replace("px", ""),
            padRight: option.dxBuilderEmailPage.mJsonCssGuideProperty("bodypage", "padding-right").replace("px", ""),
            onValueChanged: function (e) {
                e.values.forEach(function (value) {
                    option.dxBuilderEmailPage.mJsonCssGuideProperty("bodypage", value.prop, value.value)
                })
                option.onValueChanged()
            }
        })

        $("<br/>").appendTo(itemElement)
        $("<br/>").appendTo(itemElement)
        $("<div style='width:1px;white-space:nowrap;font-size:140%;font-weight:bold;' class=''>Marge du message:</div>").appendTo(itemElement)
        $("<div/>").appendTo(itemElement).dxCtrlBuilderEmailStylePadding({
            type: "padding",
            allowDefaut: false,
            padTop: option.dxBuilderEmailPage.mJsonCssGuideProperty("bodymessage", "padding-top").replace("px", ""),
            padBottom: option.dxBuilderEmailPage.mJsonCssGuideProperty("bodymessage", "padding-bottom").replace("px", ""),
            padLeft: option.dxBuilderEmailPage.mJsonCssGuideProperty("bodymessage", "padding-left").replace("px", ""),
            padRight: option.dxBuilderEmailPage.mJsonCssGuideProperty("bodymessage", "padding-right").replace("px", ""),
            onValueChanged: function (e) {
                e.values.forEach(function (value) {
                    option.dxBuilderEmailPage.mJsonCssGuideProperty("bodymessage", value.prop, value.value)
                })
                option.onValueChanged()
            }
        })

        $("<br/>").appendTo(itemElement)
        $("<br/>").appendTo(itemElement)
        $("<div style='width:1px;white-space:nowrap;font-size:140%;font-weight:bold;' class=''>Bordure du message:</div>").appendTo(itemElement)
        $("<div/>").appendTo(itemElement).dxCtrlBuilderEmailStyleBordure({
            dxBuilderEmailPage: option.dxBuilderEmailPage,
            allowDefaut: false,
            borderWidth: option.dxBuilderEmailPage.mJsonCssGuideProperty("bodymessage", "border-width"),
            borderStyle: option.dxBuilderEmailPage.mJsonCssGuideProperty("bodymessage", "border-style"),
            borderColor: option.dxBuilderEmailPage.mJsonCssGuideProperty("bodymessage", "border-color"),
            onValueChanged: function (e) {
                e.values.forEach(function (value) {
                    option.dxBuilderEmailPage.mJsonCssGuideProperty("bodymessage", value.prop, value.value)
                })
                option.onValueChanged()
            }
        })

        //$("<br/>").appendTo(itemElement)
        //$("<br/>").appendTo(itemElement)
        //$("<div style='width:1px;white-space:nowrap;font-size:140%;font-weight:bold;' class=''>Alignement du message:</div>").appendTo(itemElement)
        //$("<div/>").appendTo(itemElement).dxCtrlBuilderEmailStyleAlignement({
        //    allowDefaut: false,
        //    value: option.dxBuilderEmailPage.mJsonCssGuideProperty("bodymessage", "text-align"),
        //    onValueChanged: function (e) {
        //        option.onValueChanged()
        //    }
        //})

        $("<br/>").appendTo(itemElement)
        $("<br/>").appendTo(itemElement)
        $("<div style='width:1px;white-space:nowrap;font-size:140%;font-weight:bold;' class=''>Style du texte du message:</div>").appendTo(itemElement)
        $("<div style='padding:10px 0;'/>").appendTo(itemElement).dxCtrlBuilderEmailStyleFont({
            showAlign: false,
            value: option.dxBuilderEmailPage.mJsonCssGuideProperty("bodypage"),
            dxBuilderEmailPage: option.dxBuilderEmailPage,
            onValueChanged: function (e) {
                e.values.forEach(function (value) {
                    option.dxBuilderEmailPage.mJsonCssGuideProperty("bodypage", value.prop, value.value)
                })
                option.onValueChanged()
            }
        }).dxCtrlBuilderEmailStyleFont("instance")
    }

    function mRempliWidget(itemElement) {
        itemElement.empty()
        $("<div/>").appendTo(itemElement).dxCtrlBuilderEmailStyleBloc({
            showAlign: true,
            blocwidget: option.dxBuilderEmailPage.mJsonCssGuideProperty("blocwidget"),
            blocwidgetinner: option.dxBuilderEmailPage.mJsonCssGuideProperty("blocwidgetinner"),
            allowDefaut: false,
            dxBuilderEmailPage: option.dxBuilderEmailPage,
            onValueChanged: function (e) {
                if (typeof e.values != 'undefined') e.values.forEach(function (value) {
                    option.dxBuilderEmailPage.mJsonCssGuideProperty("blocwidget", value.prop, value.value)
                })
                if (typeof e.values_inner != 'undefined') e.values_inner.forEach(function (value) {
                    option.dxBuilderEmailPage.mJsonCssGuideProperty("blocwidgetinner", value.prop, value.value)
                })
                option.onValueChanged()
            }
        })
    }

    var currentTag = "p"
    function mRempliText(itemElement) {
        itemElement.empty()
        var ds = ["P(Texte)", "T1", "T2", "T3", "T4"]
        var dxTabs = $("<div style='width:100%'/>").appendTo(itemElement).dxTabs({
            dataSource: ds,
            width: "100%",
            stylingMode: 'secondary',
            showNavButtons: false,
            itemTemplate: function (itemData, itemIndex, itemElement) {
                itemElement.parent().css({
                    "padding-right": "5px",
                    "padding-left": "5px",
                    "min-width": "50px",
                    "background-color": theme.backgroundColorTitle
                })
                switch (itemData) {
                    case "P(Texte)":
                        itemElement.text(itemData)
                        itemElement.attr("title", "Style qui s'applique à tous les PARAGRAPHES dont les styles ne sont pas défini"); break;
                    case "T1":
                        itemElement.html("T<span style='font-size:160%;font-weight:bold;'>1</span>")
                        itemElement.attr("title", "Style qui s'applique à tous les TITRE1 dont les styles ne sont pas défini"); break;
                    case "T2":
                        itemElement.html("T<span style='font-size:140%;font-weight:bold;'>2</span>")
                        itemElement.attr("title", "Style qui s'applique à tous les TITRE2 dont les styles ne sont pas défini"); break;
                    case "T3":
                        itemElement.html("T<span style='font-size:120%;font-weight:bold;'>3</span>")
                        itemElement.attr("title", "Style qui s'applique à tous les TITRE3 dont les styles ne sont pas défini"); break;
                    case "T4":
                        itemElement.html("T<span style='font-size:100%;font-weight:bold;'>4</span>")
                        itemElement.attr("title", "Style qui s'applique à tous les TITRE4 dont les styles ne sont pas défini"); break;
                }
            },
            onSelectionChanged: function (e) {
                var jsonType = null
                currentTag = ""
                switch (e.addedItems[0]) {
                    case "P(Texte)": jsonType = option.dxBuilderEmailPage.mJsonCssGuideProperty("p"); currentTag = "p"; break;
                    case "T1": jsonType = option.dxBuilderEmailPage.mJsonCssGuideProperty("h1"); currentTag = "h1"; break;
                    case "T2": jsonType = option.dxBuilderEmailPage.mJsonCssGuideProperty("h2"); currentTag = "h2"; break;
                    case "T3": jsonType = option.dxBuilderEmailPage.mJsonCssGuideProperty("h3"); currentTag = "h3"; break;
                    case "T4": jsonType = option.dxBuilderEmailPage.mJsonCssGuideProperty("h4"); currentTag = "h4"; break;
                }
                $DivDetail.empty()
                var $Div = $("<div style='padding-top:5px;text-align:right;'/>").appendTo($DivDetail)
                $A = $("<a style='opacity:0.3;font-size:80%;' href='javascript:void(0)'>Hérite du style du texte du message</a>").appendTo($Div)
                $A.on("click", function (e) {
                    dxAccord.mSelect(0)
                    window.setTimeout(function () { dxScroll.scrollTo(999999) }, 10)
                })
                $("<div style='padding:10px 0;'/>").appendTo($DivDetail).dxCtrlBuilderEmailStyleFont({
                    value: jsonType,
                    showAlign: false,
                    allowDefaut: true,
                    dxBuilderEmailPage: option.dxBuilderEmailPage,
                    tag: currentTag,
                    onValueChanged: function (e) {
                        e.values.forEach(function (value) {
                            option.dxBuilderEmailPage.mJsonCssGuideProperty(currentTag, value.prop, value.value)
                        })
                        option.onValueChanged()
                    }
                }).dxCtrlBuilderEmailStyleFont("instance")
            }
        }).dxTabs("instance")
        var $DivDetail = $("<div style='padding:0 20px;'/>").appendTo(itemElement)
        switch (currentTag) {
            case "p": dxTabs.option("selectedIndex", 0); break;
            case "h1": dxTabs.option("selectedIndex", 1); break;
            case "h2": dxTabs.option("selectedIndex", 2); break;
            case "h3": dxTabs.option("selectedIndex", 3); break;
            case "h4": dxTabs.option("selectedIndex", 4); break;
        }

    }

    function mRempliLien(itemElement) {
        itemElement.empty()
        $("<div style='padding:10px 0;'/>").appendTo(itemElement).dxCtrlBuilderEmailStyleFont({
            showAlign: false,
            value: option.dxBuilderEmailPage.mJsonCssGuideProperty("a"),
            allowDefaut: true,
            dxBuilderEmailPage: option.dxBuilderEmailPage,
            onValueChanged: function (e) {
                e.values.forEach(function (value) {
                    option.dxBuilderEmailPage.mJsonCssGuideProperty("a", value.prop, value.value)
                })
                option.onValueChanged()
            }
        })
    }

    function mRempliBt(itemElement) {
        itemElement.empty()

        $("<div style='padding:10px 0;'/>").appendTo(itemElement).dxCtrlBuilderEmailStyleButton({
            value: option.dxBuilderEmailPage.mJsonCssGuideProperty("bouton"),
            allowDefaut: false,
            dxBuilderEmailPage: option.dxBuilderEmailPage,
            onValueChanged: function (e) {
                e.values.forEach(function (value) {
                    option.dxBuilderEmailPage.mJsonCssGuideProperty("bouton", value.prop, value.value)
                })
                option.onValueChanged()
            }
        })
    }

    function mRempliSeparateur(itemElement) {
        itemElement.empty()

        itemElement.empty()
        $("<div style='width:1px;white-space:nowrap;font-size:140%;font-weight:bold;' class=''>Largeur séparateur:</div>").appendTo(itemElement)
        $("<div/>").appendTo(itemElement).dxCtrlBuilderEmailStyleLargeur({
            dxBuilderEmailPage: option.dxBuilderEmailPage,
            allowDefaut: false,
            value: option.dxBuilderEmailPage.mJsonCssGuideProperty("separateur", "width").replace("%", ""),
            onValueChanged: function (value) {
                option.dxBuilderEmailPage.mJsonCssGuideProperty("separateur", "width", ((value.toString().length > 0) ? value + "%" : ""))
                option.onValueChanged()
            }
        })

        $("<br/>").appendTo(itemElement)
        $("<br/>").appendTo(itemElement)
        $("<div style='width:1px;white-space:nowrap;font-size:140%;font-weight:bold;' class=''>Séparateur:</div>").appendTo(itemElement)
        $("<div/>").appendTo(itemElement).dxCtrlBuilderEmailStyleBordure({
            dxBuilderEmailPage: option.dxBuilderEmailPage,
            allowDefaut: false,
            borderWidth: option.dxBuilderEmailPage.mJsonCssGuideProperty("separateur", "border-top-width").replace("px", ""),
            borderStyle: option.dxBuilderEmailPage.mJsonCssGuideProperty("separateur", "border-top-style"),
            borderColor: option.dxBuilderEmailPage.mJsonCssGuideProperty("separateur", "border-top-color"),
            onValueChanged: function (e) {
                e.values.forEach(function (value) {
                    if (value.prop == "border-width") { option.dxBuilderEmailPage.mJsonCssGuideProperty("separateur", "border-top-width", value.value) }
                    else if (value.prop == "border-style") { option.dxBuilderEmailPage.mJsonCssGuideProperty("separateur", "border-top-style", value.value) }
                    else if (value.prop == "border-color") { option.dxBuilderEmailPage.mJsonCssGuideProperty("separateur", "border-top-color", value.value) }
                })
                option.onValueChanged()
            }
        })
    }

    this.element = function () { return container }

    mConstruit();
}